import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { cancelEducationalAdvisorBatchEnrollment } from "@academy-context/write/application/use-cases/educational-advisor/batch-enrollment-cancellation/cancel-educational-advisor-batch-enrollment";

const initialState: ProcessingState = { processing: "idle" };

export const resetCancelEducationalAdvisorBatchEnrollment = createAction("educationalAdvisor/resetCancelBatchEnrollment");

export const cancelEducationalAdvisorBatchEnrollmentReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(cancelEducationalAdvisorBatchEnrollment.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(cancelEducationalAdvisorBatchEnrollment.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(cancelEducationalAdvisorBatchEnrollment.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCancelEducationalAdvisorBatchEnrollment, () => {
    return initialState;
  });
});
